import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AdminFooter = () => (
  <>
    <footer className="pm-footer">
      <div>
        © {new Date().getFullYear()}{" "}
        <a
          href="https://www.tenstep.tn/formation/"
          rel="noopener noreferrer"
          target="_blank"
          style={{ fontWeight: 600, color: "var(--text-body)", textDecoration: "none" }}
        >
          Sotetel
        </a>
        <span style={{ marginLeft: 8, color: "var(--text-dim)" }}>· StockPos</span>
      </div>
      <nav className="pm-footer__links" aria-label="Footer">
        <a href="https://www.tenstep.tn/formation/" rel="noopener noreferrer" target="_blank">
          Sotetel
        </a>
        <a href="#about" onClick={(e) => e.preventDefault()}>About</a>
        <a href="#blog" onClick={(e) => e.preventDefault()}>Blog</a>
        <a href="#license" onClick={(e) => e.preventDefault()}>License</a>
      </nav>
    </footer>
    <ToastContainer position="bottom-right" autoClose={3500} hideProgressBar newestOnTop closeOnClick />
  </>
);

export default AdminFooter;
